import React from 'react';
import styled from 'styled-components';
import { cores } from '../../../../styles/styleUtils';

const BalanceContainer = styled.div`
  margin-top: 16px;
  border: 1px solid ${cores.cinzaClaro};
  border-radius: 5px;
  padding: 16px;
`;

const BalanceTitle = styled.h3`
  color: ${cores.cinzaMedio};
  font-size: 1.1rem;
  margin-bottom: 10px;
`;

const BalanceGroup = styled.div`
  background-color: ${cores.cinzaClaro};
  padding: 16px;
  margin-bottom: 16px;
`;

const BalanceItem = styled.button`
  background-color: ${cores.branco};
  color: ${cores.chumbo};
  border: none;
  border-left: 4px solid ${cores.laranja};
  padding: 10px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;
  text-align: left;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  transition: background-color 0.2s ease;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    background-color: ${cores.cinzaClaro};
  }
`;

const SaldoValor = styled.span`
  color: ${({ saldo }) => (saldo >= 0 ? '#28a745' : '#dc3545')}; /* Verde ou vermelho */
  font-weight: bold;
`;

const BalanceSection = ({ data }) => {
  const saldoTotal = data.reduce((acc, dat) => acc + dat.saldo, 0);

  return (
    <BalanceContainer>
      <BalanceTitle>Saldo Disponível</BalanceTitle>
      <BalanceGroup>
        <BalanceItem>
          <span>Saldo Total</span>
          <SaldoValor saldo={saldoTotal}>
            {saldoTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
          </SaldoValor>
        </BalanceItem>
        {data.map((conta) => (
          <BalanceItem key={conta.id}>
            <span>Saldo {conta.nome}</span>
            <SaldoValor saldo={conta.saldo}>
              {conta.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </SaldoValor>
          </BalanceItem>
        ))}
      </BalanceGroup>
    </BalanceContainer>
  );
};

export default BalanceSection;